<template>
  <div>
    <div class="ts-flex ts-space-x-3 ts-items-center ts-mt-6">
      <h2 class="ts-text-gray-500 ts-text-base ts-capitalize ts-mb-0">
        <i class="fas fa-link ts-mr-3"></i>
        {{ $t('serviceRequest.processing') }}
      </h2>
    </div>
    <div class="ts-h-2"></div>
    <div>
      <a-steps :current="service_status" size="small">
        <a-step>
          <template slot="title">
            <b>{{ $t('serviceRequest.pending') }}</b>
          </template>
          <a-icon slot="icon" type="tag" theme="filled" />
          <span slot="description">
            {{ $t('serviceRequest.pendingDesc') }}
          </span>
        </a-step>
        <a-step>
          <template slot="title">
            <b>{{ $t('serviceRequest.progressing') }}</b>
          </template>
          <a-icon slot="icon" type="tag" theme="filled" />
          <span slot="description">{{
            $t('serviceRequest.progressingDesc')
          }}</span>
        </a-step>
        <a-step>
          <template slot="title">
            <b>{{ $t('serviceRequest.completed') }}</b>
          </template>
          <a-icon slot="icon" type="tag" theme="filled" />
          <span slot="description">{{
            $t('serviceRequest.completedDesc')
          }}</span>
        </a-step>
        <a-step>
          <template slot="title">
            <b>{{ $t('serviceRequest.payment') }}</b>
          </template>
          <a-icon slot="icon" type="tag" theme="filled" />
          <span slot="description">{{ $t('serviceRequest.paymentDesc') }}</span>
        </a-step>
      </a-steps>
    </div>
  </div>
</template>

<script>
export default {
  props: ['resource'],
  data() {
    return {
      loading: false
    }
  },
  computed: {
    service_status() {
      if (this.resource.payment_invoices_count > 0) {
        return 4
      } else {
        return this.resource.service_status
      }
    }
  },
  methods: {}
}
</script>
<style>
.ant-steps-small .ant-steps-item-custom .ant-steps-item-icon > .ant-steps-icon {
  line-height: 0px;
}
.ant-steps-horizontal:not(.ant-steps-label-vertical)
  .ant-steps-item-description {
  max-width: 300px;
}
</style>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
